import API from '~config/api';
import { ApiPromise, DataResponse, ErrorResponse } from '~globals/api';

import { SurveyCreateBody, SurveyCreateResponse } from './types';

export const SURVEY_ENPOINTS = {
  validateExistsSurveyByTrackingCode: (trackingCode: string): string =>
    `/api/v1/Track/RouteItemSourvey/ExistsRouteItemSourvey/${trackingCode}`,
  createSurvery: '/api/v1/Track/RouteItem/RouteItemSourvey',
};

export const validateExistsSurveyByTrackingCode = (
  trackingCode: string,
): ApiPromise<DataResponse<boolean>, ErrorResponse> =>
  API.get<DataResponse<boolean>, ErrorResponse>(
    SURVEY_ENPOINTS.validateExistsSurveyByTrackingCode(trackingCode),
  );

export const createSurvery = (
  data: SurveyCreateBody,
): ApiPromise<DataResponse<SurveyCreateResponse>, ErrorResponse> =>
  API.post<DataResponse<SurveyCreateResponse>, ErrorResponse>(
    SURVEY_ENPOINTS.createSurvery,
    data,
  );
